// Typed parameters for cross-entity navigation in the admin dashboard.
// Callers pass exactly one field; Dashboard.tsx routes it to the right page filter.
export interface AdminNavParams {
  customerEmail?: string;
  teacherEmail?: string;
  classroomId?: string;
  /** Pre-select a filter chip when navigating to All Orders (dashboard tiles deep-link). */
  ordersChip?: string;
  /** Pre-select an exact fulfillment status filter in All Orders (per-status tile deep-links). */
  ordersStatus?: string;
}

export type AdminNavHandler = (option: string, params?: AdminNavParams) => void;

// Display labels for sidebar/header. Internal selection keys ('Customers',
// 'Admin Users') stay stable so cross-entity nav callers don't need updates.
export const ADMIN_PAGE_LABELS: Record<string, string> = {
  Customers: 'Users',
  'Admin Users': 'Admins',
  'Print Batches': 'Print Jobs',
};
export const adminPageLabel = (key: string) => ADMIN_PAGE_LABELS[key] || key;
